import { render } from "./RmbCapital.vue?vue&type=template&id=07028b30"
import script from "./RmbCapital.vue?vue&type=script&lang=js"
export * from "./RmbCapital.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__